import { ModalHeader as FBModalHeader } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ModalHeader = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.modal.header,
    className: `${props.className}`,
  };
  return <FBModalHeader {...tmpProps}>{props.children}</FBModalHeader>;
};

export default ModalHeader;